// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__15HYg","additionalInfo":"AgreementModal_additionalInfo__211P8"};